import { V2_API_URL, V2_AUTH } from '@/domain/migrate';
import { useNetwork } from '@nftx/react';
import { query } from 'nftx.js';
import { useQueryClient } from '@tanstack/react-query';

const useInvalidateVault = () => {
  const network = useNetwork();
  const client = useQueryClient();

  return async (vaultId: string) => {
    await query({
      url: `${V2_API_URL}/${network}/vaults/${vaultId}`,
      method: 'POST',
      headers: {
        Authorization: V2_AUTH,
      },
    });
    await new Promise((res) => setTimeout(res, 3000));
    client.invalidateQueries();
  };
};

export default useInvalidateVault;
